export default "__VITE_ASSET__BVosuALZ__"